const GetFractionalOdds = {
    title: 'Example JSON for getFractionalOdds function',
    expectedOutput: '1/5',
    initialDisplayedCode: `
    {
        "rawOdds":"1200", 
        "OddsMap": {
            "fractional": [
                [
                    30001000,
                    "30000/1"
                ],
                [
                    29001000,
                    "29000/1"
                ]`,
    moreCode: `,
                [
                    28001000,
                    "28000/1"
                ],
                [
                    27001000,
                    "27000/1"
                ],
                [
                    26001000,
                    "26000/1"
                ],
                [
                    25001000,
                    "25000/1"
                ],
                [
                    24001000,
                    "24000/1"
                ],
                [
                    23001000,
                    "23000/1"
                ],
                [
                    22001000,
                    "22000/1"
                ],
                [
                    21001000,
                    "21000/1"
                ],
                [
                    20001000,
                    "20000/1"
                ],
                [
                    19001000,
                    "19000/1"
                ],
                [
                    18001000,
                    "18000/1"
                ],
                [
                    17001000,
                    "17000/1"
                ],
                [
                    16001000,
                    "16000/1"
                ],
                [
                    15001000,
                    "15000/1"
                ],
                [
                    14001000,
                    "14000/1"
                ],
                [
                    13001000,
                    "13000/1"
                ],
                [
                    12001000,
                    "12000/1"
                ],
                [
                    11001000,
                    "11000/1"
                ],
                [
                    10001000,
                    "10000/1"
                ],
                [
                    9001000,
                    "9000/1"
                ],
                [
                    8001000,
                    "8000/1"
                ],
                [
                    7001000,
                    "7000/1"
                ],
                [
                    6001000,
                    "6000/1"
                ],
                [
                    5001000,
                    "5000/1"
                ],
                [
                    4501000,
                    "4500/1"
                ],
                [
                    4001000,
                    "4000/1"
                ],
                [
                    3501000,
                    "3500/1"
                ],
                [
                    3001000,
                    "3000/1"
                ],
                [
                    2501000,
                    "2500/1"
                ],
                [
                    2001000,
                    "2000/1"
                ],
                [
                    1751000,
                    "1750/1"
                ],
                [
                    1501000,
                    "1500/1"
                ],
                [
                    1401000,
                    "1400/1"
                ],
                [
                    1251000,
                    "1250/1"
                ],
                [
                    1101000,
                    "1100/1"
                ],
                [
                    1001000,
                    "1000/1"
                ],
                [
                    901000,
                    "900/1"
                ],
                [
                    801000,
                    "800/1"
                ],
                [
                    751000,
                    "750/1"
                ],
                [
                    701000,
                    "700/1"
                ],
                [
                    651000,
                    "650/1"
                ],
                [
                    601000,
                    "600/1"
                ],
                [
                    551000,
                    "550/1"
                ],
                [
                    501000,
                    "500/1"
                ],
                [
                    476000,
                    "475/1"
                ],
                [
                    451000,
                    "450/1"
                ],
                [
                    426000,
                    "425/1"
                ],
                [
                    401000,
                    "400/1"
                ],
                [
                    376000,
                    "375/1"
                ],
                [
                    351000,
                    "350/1"
                ],
                [
                    326000,
                    "325/1"
                ],
                [
                    301000,
                    "300/1"
                ],
                [
                    276000,
                    "275/1"
                ],
                [
                    251000,
                    "250/1"
                ],
                [
                    226000,
                    "225/1"
                ],
                [
                    201000,
                    "200/1"
                ],
                [
                    181000,
                    "180/1"
                ],
                [
                    161000,
                    "160/1"
                ],
                [
                    151000,
                    "150/1"
                ],
                [
                    141000,
                    "140/1"
                ],
                [
                    131000,
                    "130/1"
                ],
                [
                    126000,
                    "125/1"
                ],
                [
                    121000,
                    "120/1"
                ],
                [
                    111000,
                    "110/1"
                ],
                [
                    101000,
                    "100/1"
                ],
                [
                    91000,
                    "90/1"
                ],
                [
                    81000,
                    "80/1"
                ],
                [
                    76000,
                    "75/1"
                ],
                [
                    71000,
                    "70/1"
                ],
                [
                    67000,
                    "66/1"
                ],
                [
                    61000,
                    "60/1"
                ],
                [
                    56000,
                    "55/1"
                ],
                [
                    51000,
                    "50/1"
                ],
                [
                    46000,
                    "45/1"
                ],
                [
                    41000,
                    "40/1"
                ],
                [
                    36000,
                    "35/1"
                ],
                [
                    35000,
                    "34/1"
                ],
                [
                    34000,
                    "33/1"
                ],
                [
                    31000,
                    "30/1"
                ],
                [
                    30000,
                    "29/1"
                ],
                [
                    29000,
                    "28/1"
                ],
                [
                    26000,
                    "25/1"
                ],
                [
                    25000,
                    "24/1"
                ],
                [
                    23000,
                    "22/1"
                ],
                [
                    21000,
                    "20/1"
                ],
                [
                    20000,
                    "19/1"
                ],
                [
                    19000,
                    "18/1"
                ],
                [
                    18000,
                    "17/1"
                ],
                [
                    17000,
                    "16/1"
                ],
                [
                    16000,
                    "15/1"
                ],
                [
                    15000,
                    "14/1"
                ],
                [
                    14000,
                    "13/1"
                ],
                [
                    13000,
                    "12/1"
                ],
                [
                    12500,
                    "23/2"
                ],
                [
                    12000,
                    "11/1"
                ],
                [
                    11500,
                    "21/2"
                ],
                [
                    11000,
                    "10/1"
                ],
                [
                    10500,
                    "19/2"
                ],
                [
                    10000,
                    "9/1"
                ],
                [
                    9500,
                    "17/2"
                ],
                [
                    9000,
                    "8/1"
                ],
                [
                    8500,
                    "15/2"
                ],
                [
                    8000,
                    "7/1"
                ],
                [
                    7500,
                    "13/2"
                ],
                [
                    7000,
                    "6/1"
                ],
                [
                    6750,
                    "23/4"
                ],
                [
                    6500,
                    "11/2"
                ],
                [
                    6400,
                    "27/5"
                ],
                [
                    6250,
                    "21/4"
                ],
                [
                    6000,
                    "5/1"
                ],
                [
                    5800,
                    "24/5"
                ],
                [
                    5750,
                    "19/4"
                ],
                [
                    5600,
                    "23/5"
                ],
                [
                    5500,
                    "9/2"
                ],
                [
                    5400,
                    "22/5"
                ],
                [
                    5250,
                    "17/4"
                ],
                [
                    5200,
                    "21/5"
                ],
                [
                    5000,
                    "4/1"
                ],
                [
                    4800,
                    "19/5"
                ],
                [
                    4750,
                    "15/4"
                ],
                [
                    4600,
                    "18/5"
                ],
                [
                    4500,
                    "7/2"
                ],
                [
                    4400,
                    "17/5"
                ],
                [
                    4350,
                    "10/3"
                ],
                [
                    4300,
                    "33/10"
                ],
                [
                    4250,
                    "13/4"
                ],
                [
                    4200,
                    "16/5"
                ],
                [
                    4000,
                    "3/1"
                ],
                [
                    3900,
                    "29/10"
                ],
                [
                    3800,
                    "14/5"
                ],
                [
                    3750,
                    "11/4"
                ],
                [
                    3700,
                    "27/10"
                ],
                [
                    3600,
                    "13/5"
                ],
                [
                    3500,
                    "5/2"
                ],
                [
                    3450,
                    "49/20"
                ],
                [
                    3400,
                    "12/5"
                ],
                [
                    3350,
                    "47/20"
                ],
                [
                    3300,
                    "23/10"
                ],
                [
                    3250,
                    "9/4"
                ],
                [
                    3200,
                    "11/5"
                ],
                [
                    3150,
                    "43/20"
                ],
                [
                    3100,
                    "21/10"
                ],
                [
                    3050,
                    "41/20"
                ],
                [
                    3000,
                    "2/1"
                ],
                [
                    2950,
                    "39/20"
                ],
                [
                    2900,
                    "19/10"
                ],
                [
                    2880,
                    "15/8"
                ],
                [
                    2850,
                    "37/20"
                ],
                [
                    2800,
                    "9/5"
                ],
                [
                    2750,
                    "7/4"
                ],
                [
                    2700,
                    "17/10"
                ],
                [
                    2650,
                    "33/20"
                ],
                [
                    2630,
                    "13/8"
                ],
                [
                    2600,
                    "8/5"
                ],
                [
                    2550,
                    "31/20"
                ],
                [
                    2500,
                    "6/4"
                ],
                [
                    2450,
                    "29/20"
                ],
                [
                    2400,
                    "7/5"
                ],
                [
                    2380,
                    "11/8"
                ],
                [
                    2350,
                    "27/20"
                ],
                [
                    2300,
                    "13/10"
                ],
                [
                    2250,
                    "5/4"
                ],
                [
                    2200,
                    "6/5"
                ],
                [
                    2180,
                    "59/50"
                ],
                [
                    2150,
                    "23/20"
                ],
                [
                    2140,
                    "57/50"
                ],
                [
                    2100,
                    "11/10"
                ],
                [
                    2080,
                    "27/25"
                ],
                [
                    2050,
                    "21/20"
                ],
                [
                    2040,
                    "26/25"
                ],
                [
                    2000,
                    "Evens"
                ],
                [
                    1980,
                    "49/50"
                ],
                [
                    1950,
                    "19/20"
                ],
                [
                    1940,
                    "23/25"
                ],
                [
                    1910,
                    "10/11"
                ],
                [
                    1900,
                    "9/10"
                ],
                [
                    1880,
                    "22/25"
                ],
                [
                    1850,
                    "17/20"
                ],
                [
                    1840,
                    "5/6"
                ],
                [
                    1830,
                    "41/50"
                ],
                [
                    1800,
                    "4/5"
                ],
                [
                    1780,
                    "10/13"
                ],
                [
                    1750,
                    "3/4"
                ],
                [
                    1730,
                    "8/11"
                ],
                [
                    1700,
                    "7/10"
                ],
                [
                    1670,
                    "4/6"
                ],
                [
                    1650,
                    "13/20"
                ],
                [
                    1640,
                    "16/25"
                ],
                [
                    1620,
                    "8/13"
                ],
                [
                    1600,
                    "3/5"
                ],
                [
                    1580,
                    "4/7"
                ],
                [
                    1550,
                    "11/20"
                ],
                [
                    1540,
                    "8/15"
                ],
                [
                    1520,
                    "13/25"
                ],
                [
                    1500,
                    "1/2"
                ],
                [
                    1480,
                    "12/25"
                ],
                [
                    1450,
                    "4/9"
                ],
                [
                    1440,
                    "11/25"
                ],
                [
                    1420,
                    "21/50"
                ],
                [
                    1400,
                    "2/5"
                ],
                [
                    1370,
                    "4/11"
                ],
                [
                    1350,
                    "7/20"
                ],
                [
                    1340,
                    "1/3"
                ],
                [
                    1330,
                    "33/100"
                ],
                [
                    1320,
                    "8/25"
                ],
                [
                    1300,
                    "3/10"
                ],
                [
                    1290,
                    "2/7"
                ],
                [
                    1280,
                    "7/25"
                ],
                [
                    1270,
                    "27/100"
                ],
                [
                    1250,
                    "1/4"
                ],
                [
                    1240,
                    "6/25"
                ],
                [
                    1230,
                    "2/9"
                ],
                [
                    1220,
                    "11/50"
                ],
                [
                    1200,
                    "1/5"
                ],
                [
                    1190,
                    "2/11"
                ],
                [
                    1170,
                    "1/6"
                ],
                [
                    1160,
                    "2/13"
                ],
                [
                    1150,
                    "1/7"
                ],
                [
                    1140,
                    "2/15"
                ],
                [
                    1130,
                    "1/8"
                ],
                [
                    1120,
                    "1/9"
                ],
                [
                    1100,
                    "1/10"
                ],
                [
                    1090,
                    "1/12"
                ],
                [
                    1080,
                    "1/14"
                ],
                [
                    1070,
                    "1/16"
                ],
                [
                    1060,
                    "1/18"
                ],
                [
                    1050,
                    "1/20"
                ],
                [
                    1040,
                    "1/25"
                ],
                [
                    1030,
                    "1/40"
                ],
                [
                    1020,
                    "1/50"
                ],
                [
                    1010,
                    "1/100"
                ],
                [
                    1000,
                    "1.00"
                ]
            ]
        }
    }`,
};

export default GetFractionalOdds;
